import React from 'react';
import { Icon } from './Icon.js';
export const IconCompose = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 3L11 13", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M14.7598 4H4V20H20V9.24023L22 7.24023V22H2V2H16.7598L14.7598 4Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconCompose.js.map